module.exports = __webpack_public_path__ + "media/images/story_ranking_mailer/rank_no2-e34c2d940572bdbcba82faaa18fc5805.png";